import React from "react";
import { Link } from "react-router-dom";
import backimg from '../../../assets/solutions-images/hero_ban_itassets.webp';
import "../solution.css"
const IntegratedRisk = () => {
    return (
        <>
            <div>
                <div
                    className="bg-cover bg-center bg-no-repeat min-h-[502px] flex flex-col gap-8 justify-center px-6 py-16 md:px-8 lg:px-16 hover_herosec"
                    style={{ backgroundImage: `url(${backimg})` }}
                >
                    <h1 style={{ wordSpacing: '8px' }} data-aos="fade-down" className="text-xl md:text-3xl lg:text-5xl font-semibold text-white w-full sm:w-full md:w-2/3 lg:w-[880px]">
                        Real-Time Risk and Resilience Management
                    </h1>
                    <p className="text-white text-sm w-full md:w-2/3 lg:w-[600px]" data-aos="fade-down">
                        Streamline your risk management with Tekpossible. We leverage the power of ServiceNow Integrated Risk Management IRM to automate your processes, reduce manual effort, and boost efficiency. Focus on what matters most – driving your business forward – while we handle the complexities of risk.
                    </p>
                    <Link
                        data-aos="zoom-in"
                        data-aos-delay="300"
                        to="/contact-us"
                        className="w-[100px] w-fit sm:w-[150px] md:w-[140px] text-semibold lg:w-[150px] bg-[#C32A7C] px-5 py-2 sm:px-6 sm:py-2.5 lg:px-7 lg:py-2 rounded-lg text-white  hover:bg-white hover:text-[#C32A7C] transition-colors duration-400 ease-in-out text-sm sm:text-sm md:text-sm lg:text-lg text-center whitespace-nowrap"
                    >
                        Contact Us
                    </Link>

                </div>
            </div>
            <div className="bg-[#FFFFFF] mt-6 mb-10">

                <div className="flex flex-col sm:justify-center text-center items-center gap-4 py-8 px-4">
                    <h1 className="text-[#1A5298] font-bold text-lg md:text-3xl">
                        How can we help you strengthen your risk posture with ServiceNow IRM?
                    </h1>
                </div>

                <div className="bg-white">
                    <div data-aos="zoom-in-down" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-10 px-4 md:px-10 lg:px-10 py-5 items-start">
                        <div className="flex flex-col items-center w-2/1 text-center justify-center lined_hoverset">
                            <h2 className="text-[#000] text-xl  lg:text-xl xl:text-xl font-semibold max-w-[200px] lg:text-center">Proactively Identify Risks</h2>
                            <div className="mt-2 flex flex-col items-center md:w-40 ">
                                <img
                                    className="object-contain my-5"
                                    src={require("../../../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-black text-center max-w-[361px]">
                                Proactively monitor risk with defined thresholds to prevent issues from escalating, minimizing disruptions and maintaining optimal performance.
                            </p>
                        </div>
                        <div className="flex flex-col items-center w-2/1 text-center justify-center lined_hoverset">
                            <h2 className="text-[#000] text-xl lg:text-xl xl:text-xl font-semibold w-2/4 text-center">Get immediate visibility</h2>
                            <div className="mt-2 flex flex-col items-center md:w-40 ">
                                <img
                                    className="object-contain my-5"
                                    src={require("../../../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-black text-center max-w-[361px]">
                                Gain a complete understanding of your organization's risk and compliance landscape with real-time data, empowering you to confidently manage risks and ensure compliance seamlessly.
                            </p>
                        </div>
                        <div className="flex flex-col items-center justify-center w-2/1 text-center justify-center lined_hoverset">
                            <h2 className="text-[#000] text-xl lg:text-xl xl:text-xl font-semibold max-w-[200px] text-center">Encourage collaborative work</h2>
                            <div className="mt-2 flex flex-col items-center md:w-40 ">
                                <img
                                    className="object-contain my-5"
                                    src={require("../../../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-black text-center max-w-[361px]">
                                Empower frontline users and teams with a frictionless experience on a single platform, enabling seamless connection and engagement. Share accurate data and gain valuable insights for internal audits.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-[#F4F4F4] w-full py-10 md:py-12">
                <div className="flex flex-col items-center text-center px-4 md:px-6">

                    <h1 className="text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-5 w-full" data-aos="fade-down" data-aos-duration="1000">
                        Our Experience with ServiceNow IRM
                    </h1>
                    <h5 data-aos="fade-up" data-aos-duration="1000" className="text-md text-black font-medium text-center w-3/4">Policy and Compliance Governance | Business Continuity Management | Operational Risk Management Audit Services Management | Risk Intelligence Management | Vendor Risk Management</h5>

                </div>
            </div>
            <div className="bg-[#FFFFFF] w-full py-10 md:py-12">
                <div className="flex flex-col items-center text-center px-4 md:px-6" data-aos="fade-up"
                    data-aos-duration="1000">

                    <h1 className="line_heightsests text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-8 max-w-[900px]">
                        Let's discuss how we can optimize your ServiceNow IRM implementation to meet your specific needs
                    </h1>
                    <Link
                        data-aos="zoom-in"
                        data-aos-delay="300"
                        to={"/contact-us"}
                        className="w-[140px] px-6 py-2 md:px-4 md:py-2.5 bg-[#C32A7C] rounded-lg text-white font-semibold 
                        hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-300 text-sm md:text-base 
                        text-center whitespace-nowrap mt-4 border border-[#C32A7C]"
                    >
                        Contact Us
                    </Link>

                </div>
            </div>
        </>
    );
}

export default IntegratedRisk;